// Slack Connect web-item ids are `<addonKey>__<moduleKey>`. The addon key is bare in prod but
// suffixed on non-prod installs (e.g. `-ddev`, `-stg-east`), so match on prefix + module suffix.
const SLACK_CONNECT_APP_ID_PREFIX = 'confluence-chats-integration';

// Module suffixes being deprecated as part of the Connect deprecation. Add future modules here.
const DEPRECATED_CONNECT_MODULE_SUFFIXES = ['__page-config-dialog-trigger', '__profile'] as const;

// Space settings is gated independently so it can be rolled back on its own, so its suffixes are
// kept out of the shared pool. Callers pass the group their feature gate controls.
export const DEPRECATED_SPACE_SETTINGS_MODULE_SUFFIXES = ['__space-config-link'] as const;

/**
 * True when the web-item id is a deprecated Confluence↔Slack Connect UI module (across all envs).
 * Pure id check with no feature gate — callers must inline `fg(...)` at the callsite and AND it
 * with this helper, e.g. `isDeprecatedConnectWebItem(id) && fg('...')`.
 *
 * Defaults to the shared Connect modules so existing callers are unaffected. Pass `moduleSuffixes`
 * to match a separately gated surface, e.g. `DEPRECATED_SPACE_SETTINGS_MODULE_SUFFIXES`.
 */
export const isDeprecatedConnectWebItem = (
	webItemId?: string | null,
	moduleSuffixes: readonly string[] = DEPRECATED_CONNECT_MODULE_SUFFIXES,
): boolean =>
	Boolean(
		webItemId?.startsWith(SLACK_CONNECT_APP_ID_PREFIX) &&
		moduleSuffixes.some((suffix) => webItemId.endsWith(suffix)),
	);
